// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "pro-fullscreen-renderer" + "." + "ebd144e3" + ".chunk.min.css";
};